module.exports = __webpack_public_path__ + "img/29.857ed4cb.jpg";